const TIPOS_NEO = [
  { 
    id: 1,
    Nombre: 'NOTIFICACION',
  },
  { 
    id: 2,
    Nombre: 'COMUNICACION',
  }
]

export {
  TIPOS_NEO
}
